import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {
	// 2021-08-02
	search(params) {
		return axios.get('/m-courier-cost-item?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-08-12
	exportExcel(params) {
		return axios.get('/m-courier-cost-item/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-08-17
	batchVerify(params) {
		return axios.put('/m-courier-cost-item/batch-verify', params);
	},

}